import { render, staticRenderFns } from "./getElectricshockStop.vue?vue&type=template&id=c2458070&scoped=true&"
import script from "./getElectricshockStop.vue?vue&type=script&lang=js&"
export * from "./getElectricshockStop.vue?vue&type=script&lang=js&"
import style0 from "./getElectricshockStop.vue?vue&type=style&index=0&id=c2458070&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2458070",
  null
  
)

export default component.exports